export default __webpack_public_path__ + "assets/images/li-check-b400b29a.svg";